import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { PanelModule } from '../../../modules/panel.module';
import { UiSettingsComponent } from '../../ui-settings/ui-settings.component';
import { HqService } from '../../../services/hq.service';
import { BusinessService } from '../../../services/business.service';

@Component({
  selector: 'brt-hq-save',
  standalone: true,
  imports: [PanelModule, UiSettingsComponent],
  templateUrl: './hq-save.component.html',
  styleUrl: './hq-save.component.scss'
})
export class HqSaveComponent {
  loading = true;
  defaultBackgroundImage = 'assets/images/gallery/banner-default.webp';
  hq: any = { Domains: [], IsPublished: true, UI: { BackgroundImage: this.defaultBackgroundImage } };

  // Business assignment
  businesses: any[] = [];
  selectedBusinessIds: string[] = [];

  constructor(private hqService: HqService, private businessService: BusinessService,
    private router: Router, private route: ActivatedRoute, private messageService: MessageService) {
    this.route.params.subscribe(async params => {
      if (params['id'])
        this.hq = await this.hqService.get(params['id']);
      this.applyDefaultUi();
      await this.loadBusinesses();
      delete this.loading;
    });
  }

  private applyDefaultUi() {
    if (!this.hq.Domains) this.hq.Domains = [];
    this.hq.UI = this.hq.UI || {};
    this.hq.UI.BackgroundImage = this.hq.UI.BackgroundImage || this.defaultBackgroundImage;
  }

  private async loadBusinesses() {
    const result = await this.businessService.search({ IsDisabled: null, IsDeleted: null, Size: 1000 });
    this.businesses = result.List || [];
    const savedBusinessIds = new Set(this.hq.BusinessIds || []);
    this.selectedBusinessIds = this.businesses
      .filter(_ => (this.hq.Id && _.HqId === this.hq.Id) || savedBusinessIds.has(_.Id))
      .map(_ => _.Id);
  }

  async save(navigate = true) {
    this.loading = true;
    try {
      this.hq.Domains = this.normalizeDomains(this.hq.Domains);
      this.hq.BusinessIds = [...this.selectedBusinessIds];
      this.hq = await this.hqService.save(this.hq);

      // Sync each business's HqId with the current selection.
      const selected = new Set(this.selectedBusinessIds);
      const changed = this.businesses.filter(b =>
        (selected.has(b.Id) ? this.hq.Id : null) !== (b.HqId || null) &&
        (selected.has(b.Id) || b.HqId === this.hq.Id));
      for (const business of changed) {
        business.HqId = selected.has(business.Id) ? this.hq.Id : null;
        await this.businessService.save(business);
      }

      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'HQ saved successfully' });
      if (navigate) this.router.navigate(['/hq']);
    } catch (err: any) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: err?.error?.message || err?.message || 'Failed to save HQ' });
    } finally {
      delete this.loading;
    }
  }

  private normalizeDomains(domains: unknown): string[] {
    if (!Array.isArray(domains)) return [];
    return [...new Set(domains
      .filter((domain): domain is string => typeof domain === 'string')
      .map(domain => domain.trim().replace(/\.$/, '').toLowerCase())
      .filter(Boolean))];
  }
}
